
    document.addEventListener('DOMContentLoaded', () => {
        const container = document.querySelector('.dryus-2448');
        const playerElement = document.getElementById('vimeo-player-dryus-2448');

        if (!container || !playerElement) {
            return;
        }

        const muteBtn = container.querySelector('.dryus-2448-mute-btn');
        const playBtn = container.querySelector('.dryus-2448-play-btn');

        // Vimeo id + native aspect ratio per breakpoint
        const BREAKPOINTS = [
            { name: 'desktop-xl', minWidth: 1561, id: 1224084013, ratio: 935 / 700 },
            { name: 'desktop', minWidth: 1024, id: 1224095375, ratio: 575 / 700 },
            { name: 'tablet', minWidth: 768, id: 1224095393, ratio: 767 / 700 },
            { name: 'mobile', minWidth: 0, id: 1224095369, ratio: 375 / 480 }
        ];

        let player = null;
        let vimeoLoaded = false;
        let isMuted = true;
        let isPlaying = true;
        let currentBreakpoint = null;

        function debounce(fn, delay) {
            let timer = null;
            return function (...args) {
                clearTimeout(timer);
                timer = setTimeout(() => fn.apply(this, args), delay);
            };
        }

        function getBreakpoint() {
            const width = window.innerWidth;

            return BREAKPOINTS.find(breakpoint => width >= breakpoint.minWidth);
        }

        function updatePlayPauseState() {
            container.classList.toggle('paused', !isPlaying);
            playBtn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
        }

        function updateMuteState() {
            container.classList.toggle('unmuted', !isMuted);
            muteBtn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
        }

        // Cover-fit the Vimeo iframe inside the container without letterboxing
        function scaleVimeoIframe() {
            const iframe = playerElement.querySelector('iframe');

            if (!iframe || !currentBreakpoint) {
                return;
            }

            const containerWidth = playerElement.offsetWidth;
            const containerHeight = playerElement.offsetHeight;

            if (!containerWidth || !containerHeight) {
                return;
            }

            const containerAspect = containerWidth / containerHeight;
            const videoAspect = currentBreakpoint.ratio;
            const scale = containerAspect > videoAspect
                ? containerWidth / (containerHeight * videoAspect)
                : containerHeight / (containerWidth / videoAspect);

            iframe.style.transform = `translate(-50%, -50%) scale(${scale})`;
        }

        function loadVimeoApi() {
            if (vimeoLoaded) {
                return Promise.resolve();
            }

            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.async = true;
                script.addEventListener('load', () => {
                    vimeoLoaded = true;
                    resolve();
                });
                script.addEventListener('error', reject);
                document.body.appendChild(script);
            });
        }

        async function createPlayer(startTime = 0) {
            currentBreakpoint = getBreakpoint();

            if (player && typeof player.destroy === 'function') {
                await player.destroy();
            }

            playerElement.innerHTML = '';

            player = new Vimeo.Player(playerElement, {
                id: currentBreakpoint.id,
                loop: true,
                autoplay: !matchMedia('(prefers-reduced-motion: reduce)').matches,
                autopause: false,
                muted: true,
                dnt: true,
                controls: false,
                playsinline: true,
                width: playerElement.offsetWidth,
                height: playerElement.offsetHeight
            });

            player.on('loaded', () => {
                if (startTime > 0) {
                    player.setCurrentTime(startTime);
                }
                player.setVolume(isMuted ? 0 : 1);
                if (matchMedia('(prefers-reduced-motion: reduce)').matches) { isPlaying = false; updatePlayPauseState(); }
                scaleVimeoIframe();
            });

            player.on('volumechange', data => { isMuted = data.volume === 0; updateMuteState(); });
            player.on('play', () => {
                isPlaying = true;
                updatePlayPauseState();
            });

            player.on('pause', () => {
                isPlaying = false;
                updatePlayPauseState();
            });
        }

        const onResize = debounce(() => {
            const breakpoint = getBreakpoint();

            if (player && currentBreakpoint && breakpoint.name !== currentBreakpoint.name) {
                createPlayer();

                return;
            }

            scaleVimeoIframe();
        }, 150);

        window.addEventListener('resize', onResize);

        muteBtn.addEventListener('click', () => {
            if (!player) {
                return;
            }

            isMuted = !isMuted;
            player.setVolume(isMuted ? 0 : 1);
            updateMuteState();
        });

        playBtn.addEventListener('click', () => {
            if (!player) {
                return;
            }

            if (isPlaying) {
                player.pause();
            } else {
                player.play();
            }
        });

        const observer = new IntersectionObserver(entries => {
            const [entry] = entries;

            if (!entry.isIntersecting) {
                return;
            }

            observer.disconnect();

            loadVimeoApi()
                .then(createPlayer)
                .catch(error => console.error('Error loading Vimeo API:', error));
        }, { rootMargin: '200px', threshold: 0 });

        observer.observe(container);
    });
